module.exports = __webpack_public_path__ + "static/media/boca-photo-0.b339ec84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/boca-photo-0.jpg
// module id = 2081
// module chunks = 0